module.exports = __webpack_public_path__ + "static/media/ic_searchtype_wreck.02779111.svg";